import React, { useEffect, useState } from "react"; import { Field, FormikProvider, Form, useFormik } from "formik"; import Menubar from "../Menubar"; import { store } from "../../App";
import {  IoIosReturnLeft } from "react-icons/io"; import Select from 'react-select';import MasterService from "../../Services/MasterService"; import { AiFillFileExcel, AiOutlineSearch, } from "react-icons/ai"; import { Container, Row, Col, Nav,  Button } from 'react-bootstrap'; import { MdOutlinePictureAsPdf } from "react-icons/md";
import "jspdf-autotable"; import { commonSelectProps, currentDate, datetime, exportToExcel, formatNumberIndianWithDecimal, generatelargePdf, generatePdf } from "../utils/commonFunctions"; import AlertModal from "../Alert/AlertModal"; import useAlert from "../Alert/useAlert";
import KpiService from "../../Services/KpiService";
export default function MandalKpiIndicatorReport() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [distEnb, setDistEnb] = useState(false); const [Mandalenb, setMandalenb] = useState(false); const [distlist, setDistrictList] = useState(); const [mandallist, setMandalList] = useState(); 
  const [Periodicitylist, setPeriodicitylist] = useState(); const [Yearlist, setYearlist] = useState(); const [Categorylist, setCategorylist] = useState(); const [searchText, setSearch] = useState(""); const [searchText1, setSearch1] = useState(""); const [Id, setId] = useState(); const [Periodicid, setperiodicId] = useState(); const [EntryData, setEntrydata] = useState(); const [entrydataEnb, setEntrydataEnb] = useState(false); const [CpoTableenb, setCpoTableenb] = useState(false); const [Asotableenb, setAsotableenb] = useState(false);
  const [Cpodata, setCpodata] = useState([]); const [Deptlist, setDeptlist] = useState([]); const [Distname, setDistname] = useState(); const [Deptname, setDeptname] = useState(); const [Mandalname, setMandalname] = useState(""); const[districts,setdistricts]= useState(); const[mandals, setMandals] = useState(); const[periodic, setperiodic] = useState(); const[years, setyears] = useState(); const[categorys, setcategorys] = useState();
   const[uniqueMandals,setuniqueMandals] =useState(); const[uniqueDepartments,setuniqueDepartments] =useState();const [Depts, setDepts] =useState();const[currentdate,setcurrentdate] =useState(''); const[currenttime,setcurrenttime] =useState('');const [selectedperiodicity, setselectedperiodicity] = useState(); const [selectedyear, setselectedyear] = useState(); const [selectedcategory, setselectedcategory] = useState();
 const [logindeptid, setlogindeptid] = useState("");
 const [ulblist, setulblist] = useState();
  const [ulbs, setulbs] = useState();

  let username = localStorage.getItem("username"); let roleid = localStorage.getItem("catid"); let district = localStorage.getItem("districtid"); let deptName = localStorage.getItem("deptName"); let mandal = localStorage.getItem("mandalid");
let deptId = localStorage.getItem("deptid");
let ulbcode = localStorage.getItem("ulbid");
let ulbname = localStorage.getItem("ulbname");
let ulbdeptlist = JSON.parse(localStorage.getItem("ulbdeptlist") || "[]");


  const formik = useFormik({ initialValues: { userId: "", district_id: "", mandal_id: "",sec_id:"",ulb_id:"",department_id:"", periodic_id:"", year:"", date:"", Indicators: [   { indicator_id: "", entry_value: "" }], remarks:"" }, onSubmit: (values) => { } })
  const periodicityMap = {  monthly: { label: "MONTHLY", value: "6" }, quarterly: { label: "QUARTERLY", value: "7" },half_yearly: { label: "HALFYEARLY", value: "5" }, annually: { label: "ANNUALLY", value: "3" }, bi_annual: { label: "BIENNIAL", value: "8" },five_years: { label: "FIVE-YEARS", value: "2" }};
  
  const perioicitylist = (dept) => {
    if (dept === "0") { const allOption = Object.keys(periodicityMap).map((key) => ({ label: periodicityMap[key].label, value: periodicityMap[key].value, }));setPeriodicitylist(allOption);return; }
  else{ let paramss = { userId: username, deptId: dept, mandal: "Yes", district: "No", state: "No", secretariat: "No", };
    KpiService.getperiodicityStatusForAchievementsEntry(paramss).then((res) => { if (res.data) { if (res.data.SCODE === "01") {
          const apiData = res.data.SDESC[0]; const options = Object.keys(periodicityMap) .filter((key) => apiData[key] > 0) .map((key) => periodicityMap[key]); setPeriodicitylist(options); } else { showAlertMessage(res.data.SDESC, "warning"); }
      }
    });
  }
  };
  
  useEffect(() => { 
    if(["111","113","114"].includes(roleid)){perioicitylist(deptId)}
    datetime(setcurrentdate,setcurrenttime);
  }, []);


 React.useEffect(() => {
    if ((roleid === "111"|| roleid === "117") || (roleid === "113" || roleid === "119"))
      { 
        setDistEnb(true); setMandalenb(true);
       }
    if (roleid === "116" ) {
      setDistEnb(false); 
    }

    if (roleid === "111" || roleid === "117") {
  if (ulbdeptlist?.includes(deptId)) {
    UlbDropDown({ userId: username, districtId: district });
    formik.setFieldValue("ulb_id", ulbcode);
    
  } else {
    formik.setFieldValue("mandal_id", mandal);
  }

  setDistname(localStorage.getItem("districtname"));
  setMandalname(
    ulbdeptlist?.includes(deptId) ? ulbname : localStorage.getItem("mandalname")
  );
}


    if(roleid !== "116"){
      setlogindeptid(deptId);
    }

    formik.setFieldValue("district_id", district)  
    let params = { "district_id": district }
    MasterService.getMandals(params).then((res) => { if (res.data) { setMandals(res.data); let options = res.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); }); setMandalList(options); } });
    formik.setFieldValue("mandal_id", mandal) 
  }, [])


 
  useEffect(() => {
   
      let paramss={ userId:username }

    if(["116", "119", "117"].includes(roleid)){
        MasterService.getDeptartments(paramss).then((res) => { if (res.data) {setDepts(res.data?.SDESC); let options = res.data?.SDESC.map((item, i) => { return ( <option key={i} value={item.dept_id}> {item.dept_name} </option> ); }); setDeptlist(options); } });
        }
    MasterService.getDistricts().then((res17) => {
      if (res17.data) { 
        setdistricts(res17.data);
        let options = res17.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); }); setDistrictList(options); }
    });
   
    // MasterService.getDeptartments(params).then((res) => { if (res.data) { let options = res.data?.SDESC.map((item, i) => { return ( <option key={i} value={item.dept_id}> {item.dept_name} </option> ); }); setDeptlist(options); } });
  //   KpiService.getPeriodicitylist(paramss).then((res20) => { if (res20.data) { setperiodic(res20.data.SDESC); let options = res20.data.SDESC.map((item, i) => { return ( <option key={i} value={item.periodic_id}> {item.periodic_name} </option> ); }); setPeriodicitylist(options); }
  //  })
  }, []);
 
const Emptyfields=()=>{ formik.setFieldValue("periodic_id",""); formik.setFieldValue("year",""); formik.setFieldValue("category",""); }

const hod=(val)=>{
  perioicitylist(val)
  setCpoTableenb(false);
  setAsotableenb(false);
  Emptyfields();setlogindeptid(val);
  if(["116"].includes(roleid) ){formik.setFieldValue("district_id",""); formik.setFieldValue("mandal_id",""); }
}
const UlbDropDown =(params)=>{
KpiService.getulbList(params).then((response) => {
        if (response.data && response.data.SCODE === "01") {
          setMandals(response.data.SDESC);
          let options = response.data.SDESC.map((item, i) => { return ( <option key={item.ulb_code} value={item.ulb_code}> {item.ulb_name} </option> );
          });
          setulblist(response.data.SDESC);
        }
      });
}
const MandalDropdown=(value)=>{
  setCpoTableenb(false);
  formik.setFieldValue("periodic_id",""); formik.setFieldValue("year",""); formik.setFieldValue("date",""); formik.setFieldValue("category","");
  setAsotableenb(false);
  if(!value){return;}
  if(ulbdeptlist.includes(logindeptid)){
      let params1 = { userId: username ,districtId: value };
       UlbDropDown(params1);
    }
    else {
  let params = { "district_id": value }
  MasterService.getMandals(params). then((res) => { if (res.data) { setMandals(res.data);let options = res.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); }); setMandalList(options); } });
  }
}
 
const YearData=(value)=>{
  setYearlist([]); setCpoTableenb(false); setperiodicId(value); setId(""); formik.setFieldValue("year",""); formik.setFieldValue("date",""); formik.setFieldValue("category",""); setAsotableenb(false); if(!value){return;}
  let params={ userId:username, periodicityId:value }
  KpiService.KpiperiodicYears(params).then((res20) => { let res=res20.data.SDESC.yearsList; setyears(res20.data.SDESC.yearsList); if (res20.data) { let options = res.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); }); setYearlist(options); } }); setYearlist([]); }


const Categorydata =
 (value) => {
  console.log("formiki",formik.values.department_id);
  if (!value) {let missingFields = []; if (!value) missingFields.push("Year"); if(missingFields.length>0){ const errorMessage = `Please Select Required Field ${missingFields.join(", ")}.`; showAlertMessage(errorMessage, "warning"); setCpoTableenb(false); setAsotableenb(false); return; } }
  setCategorylist([]); formik.setFieldValue("category",""); formik.setFieldValue("date","");
  if(roleid === "114" || roleid === "116"){ const filterdistrict = districts?.find(item=>item.id === formik.values.district_id); setDistname(filterdistrict?.value);}
      else{
      setDistname(localStorage.getItem("districtname"));} const filtermandal = mandals?.find(item=>ulbdeptlist.includes(logindeptid)? item.ulb_code === formik.values.ulb_id:item.id === formik.values.mandal_id); setMandalname(ulbdeptlist.includes(logindeptid)? filtermandal?.ulb_name:filtermandal?.value); 
      const selectedKey = Object.keys(periodicityMap).find((key) => periodicityMap[key].value === formik.values.periodic_id);
    setselectedperiodicity(selectedKey ? periodicityMap[selectedKey].label : "");
       const filteryear = years?.find(item=>item.id === value); setselectedyear(filteryear?.value); setselectedcategory(null); 
      if(["116", "119", "117"].includes(roleid)){ const filterdept = Depts?.find(item=>item.dept_id === formik.values.department_id.toString()); console.log("filtereddept",filterdept);setDeptname(filterdept?.dept_name); }
      else{ setDeptname(localStorage.getItem("deptcodeName")); } const selectedYear = value; setId(selectedYear); setCpoTableenb(false);

  if (["1", "2", "3","8","62"].includes(Periodicid) ) {
    if(["111", "117","116"].includes(roleid) ){
      const params = {
        userId: username,
        districtId: (roleid=== "119" || roleid=== "117" || roleid ==="111" ||  roleid ==="113")? district: formik.values.district_id,
        mandalId: ulbdeptlist.includes(logindeptid) ? "0":(roleid==="117"|| roleid==="111")? mandal:formik.values.mandal_id,
        ulbId: ulbdeptlist.includes(logindeptid) ? (roleid === "111")?  ulbcode:roleid === "117" ? "0": formik.values.ulb_id :"0",
        year: value, deptId:[ "119", "117","116"].includes(roleid) ? formik.values.department_id:deptId,
        periodicityId: formik.values.periodic_id, headId:"0" };
        fetchEntryData(params);
      }
    else{ let paramss={ "userId":username, "districtId":roleid=== "119" || roleid=== "117" || roleid ==="111" ||  roleid ==="113"? district: formik.values.district_id, "periodicityId":formik.values.periodic_id , "deptId" : ["117","116","119"].includes(roleid) ? formik.values.department_id:deptId , "headId": "0", "year" :value,ulbId:"0" }; countdata(paramss); }
}

else {
  const params = { userId: username, periodicityId: Periodicid, };
  KpiService.KpiperiodicYears(params). then((res) => { const response = res.data.SDESC.headList; setcategorys(res.data.SDESC.headList);
if(response){ const options = response?.map((item, i) => ( <option key={i} value={item.id}> {item.value} </option> )); setCategorylist(options); }
  else{ setCategorylist([]); } }); } }


const countdata=(paramss)=>{
  KpiService.CpoTableData(paramss).then((res) => {
    if(res.data.SCODE==="02"){ showAlertMessage(res.data.SDESC,"warning") }
  if(res.data.mandalWiseIndicatorsEntryProgressReportDataStatus.length > 0){ 
    setCpoTableenb(true); setAsotableenb(false); setCpodata(res.data.mandalWiseIndicatorsEntryProgressReportDataStatus) ; setEntrydataEnb(true); const uniqueDepartments = [ ...new Set(res.data.mandalWiseIndicatorsEntryProgressReportDataStatus?.map((item) => item.dept_name).filter(Boolean)), ]; setuniqueDepartments(uniqueDepartments);
let uniqueMandals=[];
    if(ulbdeptlist.includes(logindeptid)){
    uniqueMandals = [ ...new Set( res.data.mandalWiseIndicatorsEntryProgressReportDataStatus ?.map((item) => item.ulb_name) .filter((mandal) => mandal && mandal.trim() !== "") ), ]; 
}
else{
   uniqueMandals = [ ...new Set( res.data.mandalWiseIndicatorsEntryProgressReportDataStatus ?.map((item) => item.mandal_name) .filter((mandal) => mandal && mandal.trim() !== "") ), ]; 
  }
  console.log("unique",uniqueMandals);
    setuniqueMandals(uniqueMandals);
  }
  else{ setCpodata([]); setCpoTableenb(false); showAlertMessage("No Data Found!","warning") } }) }


const Subdata =(detail)=>{
  setMandalname(detail.mandal_name); const filterperiodic = periodic?.find(item=>item.periodic_id === parseInt(formik.values.periodic_id)); setselectedperiodicity(filterperiodic?.periodic_name); const filteryear = years?.find(item=>item.id === formik.values.year); setselectedyear(filteryear?.value); if(formik.values.category){ const filtercategory = categorys?.find(item=>item.id === parseInt(formik.values.category)); setselectedcategory(filtercategory?.value);
    }
    
    else{ setselectedcategory(null); }
  const params = {
    districtId: detail.district_id,
    mandalId: detail.mandal_code,
    year: detail.year||0,
    headId: detail.head_id||0,
    deptId: detail.dept_id,
    periodicityId:detail.periodicity_id,
    userId: username,
  };
  fetchEntryData(params);
}

const getEntrydata = (value) => {
  setEntrydataEnb(false);
  if(!value){return;}

  const filtercategory = categorys.find(item=>item.id === parseInt(value)); console.log("filtercategory",categorys); setselectedcategory(filtercategory?.value);
  
  if(["111", "117","116"].includes(roleid) ){
    const params = {
       userId: username,
       districtId: (roleid=== "119" || roleid=== "117" || roleid ==="111" ||  roleid ==="113")? district: formik.values.district_id,
       mandalId: ulbdeptlist.includes(logindeptid) ? "0":(roleid==="117" || roleid === "111")? mandal:formik.values.mandal_id,
       ulbId:ulbdeptlist.includes(logindeptid) ? formik.values.ulb_id :"0",
       year:formik.values.year, deptId: ["117","116","119"].includes(roleid) ? formik.values.department_id:deptId,
       periodicityId: formik.values.periodic_id,
       headId:value };
       fetchEntryData(params);
      }
     else { let paramss={ "userId":username, "districtId":roleid=== "119" || roleid=== "117" || roleid ==="111" ||  roleid ==="113"? district: formik.values.district_id, "periodicityId":formik.values.periodic_id , "deptId" : ["117","116","119"].includes(roleid) ? formik.values.department_id:deptId , "headId":value , "year" :formik.values.year ,ulbId:"0"}; countdata(paramss);
}
     };

const fetchEntryData = (params) => {
      store.dispatch({ type: "SHOW_SPINNER" });
  KpiService.getKpiIndicaterReportDetails(params).then((res) => {
    store.dispatch({ type: "HIDE_SPINNER" });
    if (res.data.SCODE === "02"){ showAlertMessage(res.data.SDESC, "warning"); setEntrydata([]); setEntrydataEnb(false); setAsotableenb(false); setCpoTableenb(false); }
else{
  if (res.data.SCODE === "01") { setEntrydataEnb(true); let enb =false; setCpoTableenb(false); setAsotableenb(true); setEntrydata(res.data.SDESC); res.data.SDESC.forEach(item => { if (item.indicator_value !== null) { enb = true; } }); } 
  else { showAlertMessage(res.data.SDESC, "warning"); setEntrydata([]); setEntrydataEnb(false); }
}
  }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
};

const filteredData = searchText.length > 0 && Cpodata?.length ? Cpodata.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return ( value !== null && value .toString() .toLowerCase() .includes(searchText.toLowerCase()) ); }) ); }) : Cpodata; const filteredMandals = uniqueMandals?.filter((mandal) => filteredData?.some((item) => ulbdeptlist.includes(logindeptid)? item.ulb_name === mandal:item.mandal_name === mandal) );
      const filteredData1 = searchText1.length > 0 && EntryData?.length ? EntryData.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return ( value !== null && value .toString() .toLowerCase() .includes(searchText1.toLowerCase()) ); }) ); }) : EntryData;

      const BackFunct=()=>{ setSearch(""); setCpoTableenb(true); setAsotableenb(false); setEntrydataEnb(false); }
  return (
    <>
      <Menubar /> <Container fluid  className='map-header1'  > <div className='sa-title'>
        <h2>{ulbdeptlist?.includes(logindeptid)? "ULB":"Mandal"} Level Indicators Entry <span>Report</span></h2> </div> </Container>

<Container fluid style={{ width: "87%" }} className="outer-page-content-container mt-3">
    
        <FormikProvider value={formik} > <Form onSubmit={formik.handleSubmit}> <div className='mandal-container p-4'> <Row>
              {roleid !== "116"&&<Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'>
              <label className="mb-1 fw-bold">Secretariat Name</label>
                             <Field className="mb-3 form-control" type="text" name="sec_id" value={localStorage.getItem("SectariatcodeName")} controlId="formBasicEmail" disabled={true} style={{ fontWeight: "bold" }}/> 
                           </Col>}
                           <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}  > <label className="mb-1 fw-bold"> HOD Name</label>
                            {["117","119","116"].includes(roleid) ?(
                                <Select {...commonSelectProps({ name: "department_id", options: Depts, value: formik.values.department_id, optionValueKey: "dept_id", optionLabelKey: "dept_name", formik, isDisabled: !["116","119","117"].includes(roleid), extraOnChange: (option) => { hod(option ? option.dept_id : ""); } })} />
                              ):( <Field className="mb-3 form-control" type="text" name={localStorage.getItem("deptcodeName")} value={deptName} controlId="formBasicEmail" disabled={true} style={{ fontWeight: "bold" }}/>)}
                           </Col>
                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> <label className="mb-1 fw-bold"> District </label> <span style={{ color: "red" }}> *</span>
 <Select {...commonSelectProps({ name: "district_id", options: districts, value: formik.values.district_id, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: distEnb, extraOnChange: (option) => { MandalDropdown(option?option.id:"");Emptyfields(); } })} /> </Col>
                
              {(roleid === "117" || roleid === "111" || roleid === "116") ? (
  ulbdeptlist?.includes(logindeptid) ? (
    <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='mandal-select'>
      <label className="mb-1 fw-bold"> ULB </label> <span style={{ color: "red" }}> *</span>
      <Select {...commonSelectProps({ name: "ulb_id", options: ulblist, value: formik.values.ulb_id, optionValueKey: "ulb_code", optionLabelKey:"ulb_name", formik, isDisabled: Mandalenb,
         extraOnChange: (option) => { { if(!option.ulb_code) 
         { setAsotableenb(false)} }; Emptyfields();} })} />
     
    </Col>
  ) : (
    <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='mandal-select'>
      <label className="mb-1 fw-bold"> Mandal </label> <span style={{ color: "red" }}> *</span>
      <Select {...commonSelectProps({ name: "mandal_id", options: mandals, value: formik.values.mandal_id, optionValueKey: "id", optionLabelKey:"value", formik, isDisabled: Mandalenb,
         extraOnChange: (option) => { { if(!option.id) 
         { setAsotableenb(false)} }; Emptyfields();} })} />
      
    </Col>
  )
) : null}


                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='mandal-select'>
                <label className="mb-1 fw-bold"> Periodicity </label> <span style={{ color: "red" }}> *</span>
<Select {...commonSelectProps({ name: "periodic_id", options: Periodicitylist, value: formik.values.periodic_id,
   optionValueKey: "value", optionLabelKey: "label", formik, isDisabled: false,
    extraOnChange: (option) => { YearData(option ? option.value : ""); } })} />
                </Col> 
                
  <>
    <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='mandal-select'>
    <label className="mb-1 fw-bold"> Year </label> <span style={{ color: "red" }}> *</span>
    <Select {...commonSelectProps({ name: "year", options: years, value: formik.values.year, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: false, extraOnChange: (option) => { Categorydata(option? option.id:"") } })} />
    </Col>
    {(Periodicid === "5" || Periodicid === "6" || Periodicid === "7")  && ( <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='mandal-select'> <label className="mb-1 fw-bold"> Category </label> <span style={{ color: "red" }}> *</span> 
     <Select {...commonSelectProps({ name: "category", options: categorys, value: formik.values.category, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: false, extraOnChange: (option) => { getEntrydata(option? option.id:"") } })} /> </Col> )}

    {(Periodicid === "4" && (Id === "2025" || Id === "2024")) && ( <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='mandal-select'> <label className="mb-1 fw-bold"> Date </label> <span style={{ color: "red" }}> *</span> <Field className="mb-3 form-control" type="date" name="date" onChange={(e) => { getEntrydata(e.target.value); ; formik.handleChange(e) }} max={currentDate} controlId="formBasicEmail" style={{ fontWeight: "bold" }} /> </Col> )}
  </> </Row> </div> <br/>
     {CpoTableenb&&
     <>
      <Row>
                   <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
                     <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px", }} onFocus={(e) => { e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.style.border = "1px solid #353935"; e.currentTarget.style.width = "100%"; }} onBlur={(e) => { e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.style.border = "1px solid #ddd"; e.currentTarget.style.width = "150px"; }} > <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible", }} /> <input type="text" placeholder="Search " value={searchText} onChange={(event) => setSearch(event.target.value)} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0", }} /> </div>
                   </Col>
     
                      <Col className=" mb-2 " >
                                           <button className="btn btn-danger btn-sm mx-2 pdf-btn" onClick={() => generatelargePdf("#my-table", "MandalLevelKPIIndicatorReport")} style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
                                           <button variant="success"
                                            size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", "MandalLevelKPIIndicatorReport")} > Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
                                       </Col>
                 </Row>
                 <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-2 px-2 " > 
                  <span className="style">  {" "} {ulbdeptlist.includes(logindeptid)? "ULB":"Mandal"} Level Acheivement Report Of Year {selectedyear}</span>
                   <br /> 
 <span className="style-1">HOD Name:</span> <span className="style-2">{Deptname}</span> {Distname && <><span className="style-1">District:</span> <span className="style-2">{Distname}</span></>} {Mandalname && <><span className="style-1">{ulbdeptlist.includes(logindeptid)? "ULB":"Mandal"}:</span> <span className="style-2">{Mandalname}</span></>} <span className="style-1">Periodicity:</span> <span className="style-2">{selectedperiodicity}</span>
{selectedcategory && ( <> <span className="style-1">Category:</span> <span className="style-2">{selectedcategory}</span> </> )} <div className="text-end style-1">Report On : {currentdate} {currenttime}</div> </div>
      <div id="table-scroll"className="table-scroll">
            <div className="table-wrap">
                        <table className="table table-bordered custom-table table-responsive sticky-table" id="my-table">
                          <thead style={{ borderRadius: "10px 10px 0px 0px" }} >
                           
    {entrydataEnb && (
      <>
        <tr className="text-center only-export">
          <th colSpan={filteredMandals.length * 3 + 3} style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}>
            <span className="style">  {" "} {ulbdeptlist.includes(logindeptid)? "ULB":"Mandal"} Level Acheivement Report Of Year {selectedyear}</span>
                
          </th>
        </tr>

        <tr className="text-center only-export">
          <th colSpan={filteredMandals.length * 3 + 3} style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}>
            <span style={{ color: "black" }}>HOD Name:</span>&nbsp; <span style={{ color: "#FBB040" }}>{Deptname},</span>&nbsp; {Distname && <><span style={{ color: "black" }}>&nbsp;District:</span>&nbsp; <span style={{ color: "#FBB040" }}>{Distname},</span></>}
            {Mandalname &&<><span style={{ color: "black" }}>&nbsp;Mandal:</span>&nbsp;<span style={{ color: "#FBB040" }}>{Mandalname},</span></>} <span style={{ color: "black" }}>&nbsp;Periodicity:</span>&nbsp; <span style={{ color: "#FBB040" }}>{selectedperiodicity}</span> {selectedcategory && ( <> <span style={{ color: "black" }}>,&nbsp;Category:</span>&nbsp; <span style={{ color: "#FBB040" }}>{selectedcategory}</span> </> )}
          </th>
        </tr>
         <tr className="only-export"><th colSpan={filteredMandals.length * 3 + 3}><div className="text-end style-1">Report On : {currentdate} {currenttime}</div></th></tr>
      </>
    )}


    <tr className="text-center">
      <th rowSpan={2} className="sticky-col sticky-sno">Sl.No.</th> <th  rowSpan={2} className="sticky-col sticky-INDICATOR indicator-cell" >INDICATOR</th> <th rowSpan={2} className="sticky-col sticky-UNIT ">UNIT</th>
      {filteredMandals?.map((mandal, idx) => ( <th key={idx} colSpan={3}>{mandal}</th> ))}
    </tr>

    <tr className="text-center">
      {filteredMandals?.map((_, idx) => ( <React.Fragment key={idx}> <th>NUMERATOR</th> <th>DENOMINATOR</th> <th>ACHIEVED VALUE</th> </React.Fragment> ))}
    </tr>
  </thead>

  <tbody>
    {[...new Set(filteredData.map(item => item.indicator_id))].map((indicatorId, i) => {
      const indicatorRows = filteredData.filter(item => item.indicator_id === indicatorId);
      const indicatorName = indicatorRows[0]?.indicator_name; 
      const unitName = indicatorRows[0]?.unit_name; 
      const unitCatid = indicatorRows[0]?.unit_cat_id; 

      return (
        <tr key={indicatorId}>
          <td className="sticky-col sticky-sno" style={{ textAlign: "center" }}>{i + 1}</td>
          <td className="sticky-col sticky-INDICATOR indicator-column" >{indicatorName}</td>

<td className="sticky-col sticky-UNIT "  style={{ textAlign: "left" }}>{unitName}</td>
       
          {filteredMandals.map((mandalName, idx) => {
            const match = indicatorRows.find(item => ulbdeptlist.includes(logindeptid)? item.ulb_name === mandalName:item.mandal_name === mandalName);
console.log("indicatorRows",indicatorRows);
            return (
              <React.Fragment key={idx}>
  {match?.status === "Not Yet Started" ? (
    <td colSpan={3} style={{ textAlign: "center" }}> Not Yet Started </td>
  ) : (
    <>
      <td style={{textAlign:"right"}}>{match?.numerator ?? ''}</td>
      <td style={{textAlign:"right"}}>{match?.denominator ?? ''}</td>
      <td style={{textAlign:"right"}}>{unitCatid === 1 ? formatNumberIndianWithDecimal(match?.indicator_value) : match?.indicator_value ?? ''}</td>
    </>
  )}
</React.Fragment>

            ); })} </tr> ); })}
  </tbody>
</table>
</div></div></> }
                             
                             {Asotableenb && <>
                              <Nav variant="pills" className="flex-column">
                  <Row className="tabs-row">
                    <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12} className="px-0"> </Col> <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12} className="px-0"> </Col> <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12} className="mx-4 px-4"> </Col> <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12} className="mx-4 px-4"> </Col> 
                   
                   {(!["111","117","116"].includes(roleid) && Asotableenb) && <Col  xxl={2} xl={2} lg={2} md={2} sm={12} xs={12} className=" mb-2 " > <Button variant="warning" size="sm" className="btn mx-4 mt-2  warn-btn" style={{float:"right",marginRight:"20px"}} onClick={() => { BackFunct()}}> <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "3px" }} /> Back </Button> </Col> } 
                  </Row>
               </Nav>
     <Row>
              <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
                <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px", }} onFocus={(e) => { e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.style.border = "1px solid #353935"; e.currentTarget.style.width = "100%"; }} onBlur={(e) => { e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.style.border = "1px solid #ddd"; e.currentTarget.style.width = "150px"; }} > <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible", }} /> <input type="text" placeholder="Search " value={searchText1} onChange={(event) => setSearch1(event.target.value)} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0", }} /> </div> </Col>

                 <Col className=" mb-2 " >
                                      <button className="btn btn-danger btn-sm mx-2 pdf-btn" onClick={() => generatePdf("#my-table1", "MandalLevelKPIIndicatorReport",7)} style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
                                      <button variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table1", "MandalLevelKPIIndicatorReport")} > Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
                                  </Col>
            </Row>
            <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-2 px-2 " > 
              <span className="style">  {" "} Mandal Level Acheivement Report Of Year {selectedyear}</span>
                  <br /> 
             <span className="style-1">HOD Name:</span> <span className="style-2">{Deptname}</span> {Distname && <><span className="style-1">District:</span> <span className="style-2">{Distname}</span></>} {Mandalname && <><span className="style-1">{ulbdeptlist.includes(logindeptid)? "ULB":"Mandal"}:</span> <span className="style-2">{Mandalname}</span></>} <span className="style-1">Periodicity:</span>
                 <span className="style-2">{selectedperiodicity}</span> {selectedcategory && ( <> <span className="style-1">Category:</span> <span className="style-2">{selectedcategory}</span> </> )} <div className="text-end style-1">Report On : {currentdate} {currenttime}</div> </div>
            <div id="table-scroll"className="table-scroll">
            <div className="table-wrap">
                        <table className="table table-bordered custom-table table-responsive sticky-table" id="my-table1">
                          <thead style={{ borderRadius: "10px 10px 0px 0px" }} >
                          
                          {entrydataEnb && <>
                           <tr className="text-center only-export"> <th   colSpan="7" style={{ backgroundColor: "#d4e3d8",textAlign:"center" }}>
                             <span className="style">  {" "} Mandal Level Acheivement Report Of Year {selectedyear}</span>
                 
                             </th></tr>

                          <tr className="text-center only-export"> <th   colSpan="7" style={{ backgroundColor: "#d4e3d8",textAlign:"center" }}> 
                            <span style={{color: "black" }}> HOD Name:</span> &nbsp; <span style={{color: "#FBB040" }}>{Deptname},</span>
                          <span style={{color: "black" }}>&nbsp;District:</span> &nbsp; <span style={{color: "#FBB040" }}>{Distname},</span> 
                          <span style={{color: "black" }}>&nbsp;Mandal:</span> &nbsp; <span style={{color: "#FBB040" }}>{Mandalname},</span>
                           <span style={{color: "black" }}> &nbsp;Periodicity:</span> &nbsp; <span style={{color: "#FBB040" }}>{selectedperiodicity}</span> 
                           {selectedcategory && <><span style={{color: "black" }}> ,&nbsp;Category:</span> &nbsp; <span style={{color: "#FBB040" }}>{selectedcategory}</span></>}
                            </th></tr>
                             <tr className="only-export"><th  colSpan={7}><div className="text-end style-1">Report On : {currentdate} {currenttime}</div></th></tr>
                            </>}
                            
                            <tr className="text-center ">
                              <th  className="sticky-col sticky-sno">Sl.No.</th> <th className="sticky-col sticky-INDICATOR indicator-cell" >INDICATOR</th> <th className="sticky-col sticky-UNIT " >UNIT</th> <th className="indicator-column">Formula</th> <th >NUMERATOR</th> <th >DENOMINATOR</th> <th >ACHIEVED VALUE</th>
                            </tr>
                          </thead>
                          <tbody>
                  {filteredData1?.length === 0 || filteredData1?.length === undefined ? ( <tr> <td className="text-center" colSpan="7"> <b style={{ color: "red" }}>Details Not Found</b> </td> </tr> ) : (
                    (() => {

                      return filteredData1?.map((detail, i) => {
                       return(
                          <tr key={i}>
                            <td style={{ textAlign: "center" }}  className="sticky-col sticky-sno">{i + 1}</td>
                            
                            <td style={{ textAlign: "left" }}className="sticky-col sticky-INDICATOR indicator-column"  >{detail.indicator_name}</td>
                            <td style={{ textAlign: "left" }} className="sticky-col sticky-UNIT " >{detail.unit}</td>
                            <td style={{ textAlign: "left" }} className="indicator-column">{detail.formula}</td>
                       <td style={{ textAlign: "right" }}>{detail.numerator || ""}</td>
                       <td style={{ textAlign: "right" }}>{detail.denominator || ""}</td>

                       <td style={{ textAlign: "right" }}>{detail.unit_cat_id === 1 ? formatNumberIndianWithDecimal(detail.indicator_value) : detail.indicator_value}</td>

                    
                          </tr>
                       ) }); })() )}
                </tbody> </table> </div> </div> </> }   

         </Form> </FormikProvider> </Container> <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} /> </> ); }





